import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/gdpr.js'), 'gdpr.js')
  resolveStoreModules(require('../store/search.js'), 'search.js')
  resolveStoreModules(require('../store/subscribe/index.js'), 'subscribe/index.js')
  resolveStoreModules(require('../store/notification_types/index.js'), 'notification_types/index.js')
  resolveStoreModules(require('../store/cart/index.js'), 'cart/index.js')
  resolveStoreModules(require('../store/auths/forgetPassword.js'), 'auths/forgetPassword.js')
  resolveStoreModules(require('../store/auths/login.js'), 'auths/login.js')
  resolveStoreModules(require('../store/category/list.js'), 'category/list.js')
  resolveStoreModules(require('../store/product_recommend/detail.js'), 'product_recommend/detail.js')
  resolveStoreModules(require('../store/product/detail.js'), 'product/detail.js')
  resolveStoreModules(require('../store/product/list.js'), 'product/list.js')
  resolveStoreModules(require('../store/product/search.js'), 'product/search.js')
  resolveStoreModules(require('../store/product/wishlist.js'), 'product/wishlist.js')
  resolveStoreModules(require('../store/trend_group/detail.js'), 'trend_group/detail.js')
  resolveStoreModules(require('../store/trend_group/list.js'), 'trend_group/list.js')
  resolveStoreModules(require('../store/user/referrer/index.js'), 'user/referrer/index.js')
  resolveStoreModules(require('../store/user/notification/index.js'), 'user/notification/index.js')
  resolveStoreModules(require('../store/user/notification_status/index.js'), 'user/notification_status/index.js')
  resolveStoreModules(require('../store/trend_group/city/list.js'), 'trend_group/city/list.js')
  resolveStoreModules(require('../store/trend_group/product/list.js'), 'trend_group/product/list.js')
  resolveStoreModules(require('../store/user/comment/list.js'), 'user/comment/list.js')
  resolveStoreModules(require('../store/user/order/list.js'), 'user/order/list.js')
  resolveStoreModules(require('../store/user/recipient/list.js'), 'user/recipient/list.js')
  resolveStoreModules(require('../store/user/wishlist/list.js'), 'user/wishlist/list.js')
  resolveStoreModules(require('../store/wishlist/product/destroy.js'), 'wishlist/product/destroy.js')
  resolveStoreModules(require('../store/wishlist/product/list.js'), 'wishlist/product/list.js')
  resolveStoreModules(require('../store/wishlist/product/store.js'), 'wishlist/product/store.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
